import request from '@/utils/request'

export function getAdminCommunityList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.queryAdminCommunity',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}